import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { isAuthenticated, logoutAndRedirect } from "../../commons/Auth/auth";
import { LeistFusionLogoOnDark, LFMarkOnDark } from "../../commons/PanelImagepath";
import "../PanelAssets/css/bootstrap.min.css";
import "./PanelsHeader.css";
import ServiceProviderSidebar from "../../serviceProvider/components/sidebar/Sidebar";
import { Layout, Dropdown, Avatar, Drawer, Button, ConfigProvider } from "antd";
import {
  MenuOutlined,
  CloseOutlined,
  UserOutlined,
  DownOutlined,
  LogoutOutlined
} from "@ant-design/icons";
import BreadCrump from "../BreadCrump/BreadCrump";
import NormalUserSidebar from "../../normalUsers/components/sidebar";
import SuperAdminSideBar from "../../admin/components/sidebarUpdated/SidebarUpdated";
import SubAdminSidebar from "../../subadmins/components/sidebar/Sidebar";
import { useTranslation } from "react-i18next";
import ChangeLanguageDropdown from "../ChangeLanguage";
import { isRtlLanguage } from "../../i18n.jsx";
import { useIsCompact } from "../../design-system/useMediaQuery";
import MobileBottomNav from "./MobileBottomNav";
import OfflineIndicator from "../../offline/OfflineIndicator";
import { chromeMenuTheme } from "../../design-system/theme";
const { Header, Sider, Content } = Layout;

// Pages that render without the panel chrome (auth screens included: no menu before sign-in).
const BARE_PATHS = [
  "/",
  "/login",
  "/documents",
  ...["user", "admin", "subadmin"].flatMap(area => [
    `/${area}/forgotPassword`,
    `/${area}/lockscreen`
  ])
];
const SIDER_COLLAPSED_KEY = "panel.siderCollapsed";

const readCollapsed = () => {
  try {
    return localStorage.getItem(SIDER_COLLAPSED_KEY) === "1";
  } catch {
    return false;
  }
};

const PanelsHeader = props => {
  const { t, i18n } = useTranslation("dashboard");
  const isCompact = useIsCompact();
  const rtl = isRtlLanguage(i18n.language);

  const user = isAuthenticated();
  const link =
    user?.role === 2 || user?.role === 1
      ? "user"
      : user?.role == 4
        ? "admin"
        : user?.role == 3
          ? "subadmin"
          : user?.role == 0
            ? "client"
            : "client";

  const location = useLocation();
  const pathused = location.pathname;
  const nameFromPathName = pathused.split("/");
  const specialpathname =
    nameFromPathName[2]?.charAt(0).toUpperCase() + nameFromPathName[2]?.slice(1);
  const finalpathname =
    pathused === "/user/offers/auftragssuche"
      ? "Find jobs"
      : pathused === "/user/vendor-contracts"
        ? "Contracts & subscriptions"
        : specialpathname === "Room-management"
          ? "Room management"
          : specialpathname === "Warranty"
            ? "Acceptance & warranty"
          : specialpathname === "Site-docs"
            ? "Site documentation"
            : specialpathname === "Site-diary"
              ? "Site diary"
            : specialpathname === "Work-reports"
              ? "Work reports"
              : specialpathname === "Safety"
                ? "Occupational safety"
                : specialpathname === "Berichtsheft"
                  ? "Training record"
              : specialpathname === "Maintenance"
                ? "Maintenance & inspections"
              : specialpathname === "Materials"
              ? "Materials & articles"
              : specialpathname === "Dispatch"
                ? "Dispatch board"
              : specialpathname === "My-day"
                ? "My day"
              : specialpathname === "Employees-profile"
                ? "Employees Profile"
                : specialpathname && specialpathname === "Shifts-planning"
                  ? "Shifts Planning"
                  : specialpathname && specialpathname === "Predefinedvalues"
                    ? "Predefined Values"
                    : specialpathname;
  // Top-level pages outside a role area (/chats, /meetings, /documents) are named by their own segment.
  const topLevelName = ["user", "client", "admin", "subadmin"].includes(nameFromPathName[1])
    ? ""
    : nameFromPathName[1]?.charAt(0).toUpperCase() + nameFromPathName[1]?.slice(1);
  const isHome = ["/user", "/client", "/admin", "/subadmin"].includes(pathused);
  const pageTitle = isHome
    ? t("Dashboard")
    : finalpathname
      ? t(finalpathname)
      : topLevelName
        ? t(topLevelName)
        : "";

  const [label1, setLabel1] = useState(localStorage.getItem("label1"));
  const [label2, setLabel2] = useState(localStorage.getItem("label2"));
  const [collapsed, setCollapsed] = useState(readCollapsed);
  const [navOpen, setNavOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("label1", label1);
    localStorage.setItem("label2", label2);
  }, [label1, label2]);

  useEffect(() => {
    try {
      localStorage.setItem(SIDER_COLLAPSED_KEY, collapsed ? "1" : "0");
    } catch {
      // storage blocked (private mode): the sider just won't remember its state
    }
  }, [collapsed]);

  // Navigating from the drawer should land on the page, not leave the menu covering it.
  useEffect(() => {
    setNavOpen(false);
  }, [pathused]);

  useEffect(() => {
    if (!isCompact) setNavOpen(false);
  }, [isCompact]);

  const handleLogout = e => {
    e.preventDefault();
    logoutAndRedirect();
  };

  const roleLabel =
    user?.role === 2
      ? t("Service Provider")
      : user?.role === 3
        ? t("Sub Administrator")
        : user?.role === 4
          ? t("Super Admin")
          : t("User");

  const Personalitems = [
    {
      key: "who",
      type: "group",
      label: (
        <div className="app-usermenu__head">
          <span className="app-usermenu__name">
            {user?.firstName} {user?.lastName}
          </span>
          <span className="app-usermenu__role">{roleLabel}</span>
        </div>
      )
    },
    { type: "divider" },
    {
      key: "profile",
      icon: <UserOutlined />,
      label: <Link to={`/${link}/profile`}>{t("My Profile")}</Link>
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      danger: true,
      label: (
        <a href="#" onClick={handleLogout}>
          {t("Logout")}
        </a>
      )
    }
  ];

  const sidebar =
    link === "user" ? (
      <ServiceProviderSidebar
        setLabel1={setLabel1}
        setLabel2={setLabel2}
        label1={label1}
        label2={
          nameFromPathName[2] === ""
            ? label2
            : nameFromPathName[2]?.charAt(0).toUpperCase() + nameFromPathName[2]?.slice(1)
        }
      />
    ) : link === "admin" ? (
      <SuperAdminSideBar setLabel1={setLabel1} setLabel2={setLabel2} />
    ) : link === "subadmin" ? (
      <SubAdminSidebar />
    ) : (
      <NormalUserSidebar
        setLabel1={setLabel1}
        setLabel2={setLabel2}
        label1={label1}
        label2={label2}
      />
    );

  if (BARE_PATHS.includes(pathused)) {
    return (
      <Layout className="app-shell app-shell--bare">
        <Content className="app-content">{props.children}</Content>
      </Layout>
    );
  }

  const showBottomNav = isCompact && link === "user";
  const hideBreadcrumb = isHome || pathused === "/chats" || pathused === "/chat";
  const initials =
    `${user?.firstName?.[0] || ""}${user?.lastName?.[0] || ""}`.toUpperCase() || undefined;
  const homeLink = `/${link}`;

  const userAvatar = size => (
    <Avatar size={size} className="app-avatar" icon={initials ? undefined : <UserOutlined />}>
      {initials}
    </Avatar>
  );

  const headerActions = (
    <div className="app-topbar__actions">
      <OfflineIndicator />
      <ChangeLanguageDropdown />
      <Dropdown menu={{ items: Personalitems }} trigger={["click"]} placement="bottomRight">
        <button type="button" className="app-topbar__user" aria-label={t("My Profile")}>
          {userAvatar(isCompact ? 34 : 38)}
          {!isCompact && (
            <span className="app-topbar__user-text">
              <span className="app-topbar__user-name">
                {user?.firstName} {user?.lastName}
              </span>
              <span className="app-topbar__user-role">{roleLabel}</span>
            </span>
          )}
          {!isCompact && <DownOutlined className="app-topbar__user-caret" aria-hidden="true" />}
        </button>
      </Dropdown>
    </div>
  );

  const brand = (
    <Link to={homeLink} className="app-sider__brand" aria-label="LeistFusion">
      <img
        src={collapsed ? LFMarkOnDark : LeistFusionLogoOnDark}
        alt="LeistFusion"
        className={collapsed ? "is-mark" : undefined}
      />
    </Link>
  );

  return (
    <Layout
      className={`app-shell${showBottomNav ? " app-shell--with-bottomnav" : ""}${
        isCompact ? " app-shell--compact" : ""
      }`}
    >
      {!isCompact && (
        <Sider
          className="app-sider"
          theme="light"
          width={264}
          collapsedWidth={76}
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
          reverseArrow={rtl}
        >
          {brand}
          <ConfigProvider theme={chromeMenuTheme}>
            <div className="app-sider__nav">{sidebar}</div>
          </ConfigProvider>
        </Sider>
      )}

      <Layout className="app-shell__main">
        <Header className="PanelsHeader app-topbar">
          {isCompact && (
            <Button
              type="text"
              className="app-topbar__icon-btn"
              icon={<MenuOutlined />}
              onClick={() => setNavOpen(true)}
              aria-label={t("Menu")}
              aria-expanded={navOpen}
            />
          )}
          <div className="app-topbar__heading">
            {!isCompact && !hideBreadcrumb && (
              <BreadCrump label={t(label1)} link2Name={finalpathname} />
            )}
            <h1 className="app-topbar__title" title={pageTitle}>
              {pageTitle}
            </h1>
          </div>
          {headerActions}
        </Header>

        <Content className="app-content">
          <div className="app-content__inner">{props.children}</div>
        </Content>
      </Layout>

      {isCompact && (
        <Drawer
          rootClassName="app-nav-drawer"
          open={navOpen}
          onClose={() => setNavOpen(false)}
          placement={rtl ? "right" : "left"}
          width="min(320px, 86vw)"
          closable={false}
          styles={{ body: { padding: 0 }, header: { display: "none" } }}
        >
          <div className="app-nav-drawer__head">
            <img src={LeistFusionLogoOnDark} alt="LeistFusion" />
            <Button
              type="text"
              className="app-topbar__icon-btn"
              icon={<CloseOutlined />}
              onClick={() => setNavOpen(false)}
              aria-label={t("Close")}
            />
          </div>
          <Link to={`/${link}/profile`} className="app-nav-drawer__user">
            {userAvatar(44)}
            <div>
              <div className="app-nav-drawer__name">
                {user?.firstName} {user?.lastName}
              </div>
              <div className="app-nav-drawer__role">{roleLabel}</div>
            </div>
          </Link>
          <ConfigProvider theme={chromeMenuTheme}>
            <div className="app-nav-drawer__menu">{sidebar}</div>
          </ConfigProvider>
        </Drawer>
      )}

      {showBottomNav && <MobileBottomNav onOpenMenu={() => setNavOpen(true)} menuOpen={navOpen} />}
    </Layout>
  );
};

export default PanelsHeader;
